import { UI_Accordion } from 'ui/components/3-organisms/Accordion/Accordion';

interface Props {
	content: {
		properties: {
			title: string;
			accordionItems: {
				content: {
					properties: {
						id: string;
						title: string;
						htmlContent: string;
					};
				};
				settings: {
					properties: {
						openByDefault: boolean;
					};
				};
			}[];
		};
	};
	settings: {
		properties: {
			allowMultiple: boolean;
		};
	};
}

export const Accordion = ({ content, settings }: Props) => {
	const { accordionItems } = content?.properties ?? {};

	return (
		<UI_Accordion
			accordionHeading={content?.properties?.title}
			accordionItems={accordionItems.map(({ content, settings }) => {
				const { htmlContent, title, id } = content?.properties ?? {};
				const { openByDefault } = settings?.properties ?? {};

				return {
					id,
					htmlContent: htmlContent ?? null,
					title: title ?? null,
					openByDefault: openByDefault ?? false,
				};
			})}
			allowMultipleOpen={settings?.properties?.allowMultiple ?? false}
		/>
	);
};
